import React, { createContext } from 'react';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyBqW03Ps5U0j5gBzFPKHugvOB8HeRgCNJc",
  authDomain: "localhost:3000",
  projectId: "fintorro-website",
  storageBucket: "fintorro-website.appspot.com",
  messagingSenderId: "323588876484",
  appId: "1:323588876484:web:b6e0655caf83e183384191",
  measurementId: "G-K8EM0MTH6M"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// ✅ Export the context and provider correctly
export const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
  return (
    <FirebaseContext.Provider value={auth}>
      {children}
    </FirebaseContext.Provider>
  );
};
